import apiClient from '@/services/api_client_saas.js'

export const state = {
  tasks: []
}

export const getters = {
  translateTasks: state => {
    if (typeof state.tasks === 'undefined') {
      return []
    }
    return state.tasks.filter(t => t.service === 'translate').sort((a, b) => (a.created_at < b.created_at) ? 1 : -1)
  },
  transcribeTasks: state => {
    if (typeof state.tasks === 'undefined') {
      return []
    }
    return state.tasks.filter(t => t.service === 'transcribe').sort((a, b) => (a.created_at < b.created_at) ? 1 : -1)
  },
  tasks: state => {
    return state.tasks
  },
  getTaskById: (state) => (id) => {
    if (typeof state.tasks === 'undefined') {
      return null
    }
    return state.tasks.find(task => task.id === id)
  }
}

export const mutations = {
  SET_TASKS (state, taskList) { // Sets the initial tasklist
    state.tasks = taskList
  },
  APPEND_TASKS (state, taskList) { // Adds additional tasks
    state.tasks = state.tasks.concat(taskList)
  },
  INSERT_TASKS (state, taskList) { // Takes an array of tasks and inserts them at the beginning
    taskList.forEach(t => {
      state.tasks.unshift(t)
    })
  },
  PUT_TASK (state, task) { // Update a task if it already exists or insert a new one
    // console.log('Putting task')
    // console.log(task)
    if (typeof state.tasks === 'undefined') {
      state.tasks = []
    }
    const index = state.tasks.findIndex(t => t.id === task.id)
    // console.log('index')
    // console.log(index)
    if (index === -1) {
      state.tasks.unshift(task)
    } else {
      // state.tasks[index] = task // <--- this is NOT reactive. found this wasn't reactive so instead replace the item:
      // You can use Array.splice to solve this problem:
      state.tasks.splice(index, 1, task)
    }
  },
  UPDATE_TASK_ATTRIBUTE (state, args) { // expects a list of [taskId, attr, value]
    const [taskId, attr, value] = args
    state.tasks.filter(t => t.id === taskId).forEach(t => {
      t[attr] = value
    })
  }
}

export const actions = {
  loadTasks ({ context }, service = '', page = 0, limit = 200) {
    const url = `/tasks?service=${service}` + ((page > 0) ? `&page=${page}` : `&limit=${limit}`)
    return apiClient
      .get(url)
      .then(response => {
        // Success 🎉
        const tasks = response.data
        // console.log(tasks)
        // const headers = response.headers
        // console.log(headers)
        tasks.forEach(t => this.commit('PUT_TASK', t))
        // Check if there are any tasks we need to check the status of - ie. which may be blocked/stuck in the queue.
        // ie. status not in (failed/completed) and not particulary recent (10 minutes)
        tasks.forEach(t => {
          if ((new Date() - Date.parse(t.created_at)) > (60 * 60 * 1000)) { // 60 minutes
            if (!['completed', 'failed', 'n/a'].includes(t.api_status)) {
              apiClient.get('/tasks/' + t.id + '/latest')
                .then(response => {
                  // console.log(response.data)
                  this.commit('PUT_TASK', response.data)
                }).catch(console.error)
            }
          }
        })
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
            * The request was made and the server responded with a
            * status code that falls out of the range of 2xx
            */
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          /*
            * The request was made but no response was received, `error.request`
            * is an instance of XMLHttpRequest in the browser and an instance
            * of http.ClientRequest in Node.js
            */
          console.log(error.request)
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message)
        }
        return Promise.reject(error)
      })
  },
  insertTasks (context, values) {
    // context == { state, commit, rootState }
    this.commit('INSERT_TASKS', values)
  },
  putTask (context, task) {
    this.commit('PUT_TASK', task)
  },
  updateTaskAttribute (context, taskId, attr, value) {
    this.commit('UPDATE_TASK_ATTRIBUTE', taskId, attr, value)
  }
}
